module.exports = __webpack_public_path__ + "static/media/monk-face.ea6afebb.svg";